import React, { useCallback, useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import { EditorState, Extension } from '@codemirror/state';
import { Decoration, ViewUpdate, ViewPlugin } from '@codemirror/view';
import './index.less'
import { isValidEVMAddress } from '@/utils/methods';
import { useTranslation } from 'react-i18next';

function highlightDuplicatesPlugin(setShowDuplicateAlert: any, setShowInvalidAlert: any, opType: any = 'simple', onError: any) {
  return ViewPlugin.fromClass(class {
    decorations;

    constructor(view: any) {
      this.decorations = this.findDuplicates(view.state);
    }

    update(update: any) {
      if (update.docChanged) {
        this.decorations = this.findDuplicates(update.state);
      }
    }

    findDuplicates(state: any) {
      const decorations: any = [];
      const text = state.doc.toString();
      const lines = text.split('\n');
      const seen = new Map();
      let foundDuplicate = false;
      let foundInvalid = false;

      lines.forEach((line: any, index: any) => {
        const arr = line.split(',');
        const addressPart = arr[0].trim();
        const hasComma = arr.length > 1;
        const hasAmount = arr.length > 1 && arr[1].trim() !== ''; // 确保逗号后有金额

        // 简单模式下，行中不应该有逗号
        const isSimpleInvalid = opType === 'simple' && hasComma;
        // 复杂模式下，行中必须有逗号和金额
        const isMoreInvalid = opType === 'custom' && (!hasComma || !hasAmount);

        if (seen.has(addressPart) && addressPart !== '') {
          foundDuplicate = true;
          const deco = Decoration.line({ attributes: { class: 'red-background' } });
          decorations.push(deco.range(state.doc.line(index + 1).from));
        } else if (addressPart !== '' && (!isValidEVMAddress(addressPart) || isSimpleInvalid || isMoreInvalid)) {
          foundInvalid = true;
          const deco = Decoration.line({ attributes: { class: 'invalid-background' } });
          decorations.push(deco.range(state.doc.line(index + 1).from));
        } else if (addressPart !== '') {
          seen.set(addressPart, true);
        }
      });

      setShowDuplicateAlert(foundDuplicate);
      setShowInvalidAlert(foundInvalid);
      onError && onError(foundInvalid||foundDuplicate)
      return Decoration.set(decorations, true);
    }
  }, {
    decorations: v => v.decorations
  });
}

export default function CodeMirrorInput(props: any) {
  const { placeholder, onInputCode, code, opType, onError } = props
  const [value, setValue] = useState(code || "");
  const [extensions, setExtensions] = useState<any>([]);
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
  const [showInvalidAlert, setShowInvalidAlert] = useState(false);
  const { t } = useTranslation()
  
  useEffect(() => {
    setExtensions([
      javascript({ jsx: true }),
      highlightDuplicatesPlugin(setShowDuplicateAlert, 
        setShowInvalidAlert, 
        opType,
        onError)
    ]);
  }, [opType, onError]);
  const onChange = useCallback((val: any, viewUpdate: any) => {
    // console.log('val:', val)
    setValue(val);
    onInputCode && onInputCode(val)
  }, [])

  // useEffect(() => {
  //   onError && onError(showInvalidAlert || showDuplicateAlert)
  // }, [showInvalidAlert, showDuplicateAlert] )


  function renderTipsInvalid() {
    if (opType === 'custom') {
      return <p className='error'>{ t("batchTransfer.invalidInputFormatSplit") }</p>
    }
    return <p className='error'>{ t("batchTransfer.invalidWalletAddressesInRecipientList") }</p>
  }

  return (<div className='code-mirr-box'>
    <div className='code-mirr'>
      <CodeMirror 
      value={value} 
      minHeight="272px" 
      maxHeight='500px'
      placeholder={placeholder}
      extensions={extensions} 
      onChange={onChange} />
    </div>
    {
      showDuplicateAlert && <p className='error'>{ t("batchTransfer.duplicateReceivingAddresses") }</p>
    }
    {
      showInvalidAlert && renderTipsInvalid()
    }
  </div>)
}